import { useMemo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getBannerHome } from "./../../../pages/Home/redux/actions"

export const useBanner = (params) => {
  const dispatch = useDispatch();
  const { banners, isProcessingBanner } = useSelector(state => state.homeReducers);

  useEffect(() => {
    dispatch(getBannerHome(params));
  }, [dispatch, getBannerHome, params]);

  return [banners, isProcessingBanner]
};


export const useUser = () => {
  const auth = useSelector(state => state.authReducers);
  const user = auth.userInfo

  return useMemo(() => {
    return {
      user,
    };
    //eslint-disable-next-line
  }, [user]);
};
